import {groq} from 'next-sanity';

import type {SanityArray} from '@/sanity/lib/types';

import type {DocumentListSelectionSchema} from './schema';

export const DOCUMENT_LIST_SELECTION_FRAGMENT = groq`
	...,
	documentationFiles[] {
		_key,
		title,
		"href": asset->.url
	}
`;

export type DocumentListSelectionFragmentType = Omit<
	DocumentListSelectionSchema,
	'documentationFiles'
> & {
	documentationFiles: SanityArray<{
		title: string;
		href: string;
	}>;
};
